<template>
    <div class="voice-message-bubble">
        <div class="voice-content" @click="togglePlay">
            <img
                :src="require('@/assets/images/svg/voice.svg')"
                class="voice-icon"
                :class="{ 'playing': isPlaying }"
                alt="语音"
            />
            <div class="voice-duration">{{ formatDuration(duration) }}</div>
        </div>
        
        <audio 
            ref="audioElement" 
            :src="audioUrl" 
            @ended="onAudioEnded"
            @timeupdate="onTimeUpdate"
            preload="metadata"
        ></audio>
    </div>
</template>

<script>


export default {
    name: 'VoiceMessageBubble',
    props: {
        audioUrl: {
            type: String,
            required: true
        },
        duration: {
            type: Number,
            required: true
        },
        text: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isPlaying: false,
            currentTime: 0
        }
    },
    methods: {
        togglePlay() {
            const audio = this.$refs.audioElement
            if (this.isPlaying) {
                audio.pause()
                this.isPlaying = false
            } else {
                audio.play()
                this.isPlaying = true
            }
        },

        onAudioEnded() {
            this.isPlaying = false
            this.currentTime = 0
        },

        onTimeUpdate() {
            this.currentTime = this.$refs.audioElement.currentTime
        },

        formatDuration(seconds) {
            const mins = Math.floor(seconds / 60)
            const secs = Math.floor(seconds % 60)
            return `${mins}:${secs.toString().padStart(2, '0')}`
        }
    }
}
</script>

<style scoped>
.voice-message-bubble {
    max-width: 200px;
    margin: 4px 0;
}

.voice-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 8px 20px;
    background: rgba(80, 80, 85, 0.85);
    backdrop-filter: blur(10px);
    border-radius: 24px;
    border: 1.5px solid rgba(255, 255, 255, 0.9);
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;
    user-select: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    min-width: 90px;
}

.voice-content:hover {
    background: rgba(70, 70, 75, 0.9);
    border-color: rgba(255, 255, 255, 1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
    transform: translateY(-1px);
}

.voice-content:active {
    transform: translateY(0);
}

.voice-icon {
    width: 18px;
    height: 18px;
    filter: brightness(0) invert(1);
    flex-shrink: 0;
    transition: all 0.3s ease;
}

.voice-icon.playing {
    animation: pulse-icon 1.5s ease-in-out infinite;
}

@keyframes pulse-icon {
    0%, 100% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(1.1);
        opacity: 0.8;
    }
}

.voice-duration {
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: rgba(255, 255, 255, 0.95);
    white-space: nowrap;
}

.voice-text {
    font-size: 12px;
    opacity: 0.9;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

audio {
    display: none;
}
</style>
